<template>
  <button
    class="button-container"
    :class="{
      'button-container disabled': disabled,
      'button-container grey': grey
    }"
    :type="type"
    :style="customStyle"
    :disabled="disabled"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'StyledButton',
  props: {
    type: String,
    customStyle: String,
    disabled: Boolean,
    grey: Boolean
  }
};
</script>

<style scoped lang="scss">
.button-container {
  width: 100%;
  height: 70px;
  background-color: $colorGreen;
  border-radius: 4px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 35px;
  text-align: center;
  letter-spacing: -0.04em;
  color: #ffffff;
  cursor: pointer;
  outline: none;
  border: none;
  padding: 0;

  &.disabled {
    background-color: #49a75c;
  }

  &.grey {
    background-color: #d5d8df;
  }
}
</style>
